import { Injectable, inject } from '@angular/core';

import { BottomNavigationStacksService } from '@frontend/sports/web/navigation-data-access';
import { BottomNavService, OnAppInit } from '@frontend/vanilla/core';

import { BottomNavActionsService } from '../bottom-nav/bottom-nav-actions.service';

@Injectable({
    providedIn: 'root',
})
export class BottomNavBootstrapService implements OnAppInit {
    private bottomNavService = inject(BottomNavService);
    private bottomNavActionsService = inject(BottomNavActionsService);
    private bottomNavigationStacksService = inject(BottomNavigationStacksService);

    onAppInit(): void {
        this.bottomNavService.whenReady.subscribe(() => {
            this.bottomNavActionsService.init();
            this.bottomNavigationStacksService.init();
        });
    }
}
